import React from "react";
import "./LaunchSection.css";

export default function LaunchSection() {
  return (
    <section className="launch-section">
      <div className="launch-background">
        <div className="gradient-circle circle-1"></div>
        <div className="gradient-circle circle-2"></div>
        <div className="gradient-circle circle-3"></div>
      </div>

      <div className="container">
        <div className="launch-content">
          <div className="launch-badge">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 2L10.5 6.5L15.5 7.5L11.5 11.5L12.5 16.5L8 14L3.5 16.5L4.5 11.5L0.5 7.5L5.5 6.5L8 2Z" fill="currentColor"/>
            </svg>
            Fast Launch Ready
          </div>

          <h2 className="launch-title">
            Launch your iGaming Platform in <span className="highlight-text">10 Days</span>
          </h2>

          <p className="launch-description">
            Start Fast, Scale Big, And Dominate.
          </p>

          <div className="launch-features">
            <div className="feature-item">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M16.5 5L7.5 14L3.5 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Quick Setup</span>
            </div>
            <div className="feature-item">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M16.5 5L7.5 14L3.5 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Full Support</span>
            </div>
            <div className="feature-item">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M16.5 5L7.5 14L3.5 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>Scalable Platform</span>
            </div>
          </div>

          <a href="#contact" className="launch-cta">
            <span>Book Your Call Now</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M4 10h12m0 0l-4-4m4 4l-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}
